import { IsDate, IsIn, IsOptional, IsString, IsUUID } from 'class-validator';
import {
  ALLERGEN_DECLARATION_ACTIONS,
  type AllergenDeclarationAction,
} from './allergen-declaration-action.enum';
import { ALLERGEN_CATEGORY_KINDS, type AllergenCategoryKind } from './ingredient-allergen.dto';

/**
 * Append-only trail of `IngredientAllergenHistory`. A REMOVED row is the
 * dangerous edit (an allergen disappearing from a label) and must stay
 * visible forever, even after the live `IngredientAllergen` row is gone.
 */
export class IngredientAllergenHistoryResponseDto {
  @IsUUID()
  id!: string;

  @IsUUID()
  ingredientId!: string;

  @IsUUID()
  allergenId!: string;

  @IsOptional()
  @IsUUID()
  substanceId?: string | null;

  @IsIn(ALLERGEN_CATEGORY_KINDS)
  category!: AllergenCategoryKind;

  @IsIn(ALLERGEN_DECLARATION_ACTIONS)
  action!: AllergenDeclarationAction;

  @IsOptional()
  @IsUUID()
  byId?: string | null;

  /**
   * `null` when the caller is a tenant reading a row it does not own (the
   * promoted global catalog): naming who declared/removed this allergen
   * would leak that tenant's staff identity to every other tenant using the
   * same ingredient. See `ingredient-response.mapper.ts`.
   */
  @IsOptional()
  @IsString()
  byName?: string | null;

  @IsDate()
  at!: Date;

  @IsOptional()
  @IsUUID()
  sourceDocumentId?: string | null;
}
